import { Row, Text } from '@atom-web/micros'
import React from 'react'

export default function SalesIncentive() {
	return (
		<Row
			css={{
				backgroundColor: '#98FF53',
				borderRadius: '6px',
				padding: '6px',
				width: 'fit-content',
				height: 'fit-content',
				position: 'absolute',
				zIndex: '$max',
				top: '10px',
				left: '10px',
			}}
		>
			<Text
				css={{
					color: '#0E0D12',
					fontSize: '14px',
					fontWeight: 'normal',
					lineHeight: '16px',
					backgroundColor: '#98FF53',
					padding: '0px',
				}}
			>
				₹
			</Text>
			<Text
				css={{
					color: '#0E0D12',
					fontSize: '14px',
					fontWeight: '600',
					lineHeight: '16px',
					marginLeft: '2px',
					backgroundColor: '#98FF53',
					paddingLeft: '0px',
				}}
			>
				Sales Incentive
			</Text>
		</Row>
	)
}
